module.exports = __webpack_public_path__ + "static/media/modal@2x.0ca36d75.png";